module.exports = __webpack_public_path__ + "img/2285.8dd052cc.gif";